import { render, staticRenderFns } from "./VehicleNode.vue?vue&type=template&id=6b311cf5&scoped=true"
import script from "./VehicleNode.vue?vue&type=script&lang=js"
export * from "./VehicleNode.vue?vue&type=script&lang=js"
import style0 from "./VehicleNode.vue?vue&type=style&index=0&id=6b311cf5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b311cf5",
  null
  
)

export default component.exports